import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'zer-zer-example-lib',
  template: `
    <p>
      zer-example-lib works!
    </p>
  `,
  styles: []
})
export class ZerExampleLibComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
